import React, { FC } from 'react';
import { List } from '@chakra-ui/react';
const ChakraListItem = List.Item;
const ChakraListIcon = List.Indicator;
import { Icon, IconProps as CoreIconProps } from '../Icon';

type Props = Pick<CoreIconProps, 'iconName' | 'size'> & {
  children?: React.ReactNode;
  iconColor?: CoreIconProps['color'];
  iconPrefix?: CoreIconProps['prefix'];
  textStyle?: string;
  display?: string;
};

export const IconListItem: FC<Props> = ({
  children,
  iconColor,
  iconName,
  iconPrefix,
  textStyle = 'p2',
  size = '1x',
  display = 'flex',
}) => {
  return (
    <ChakraListItem textStyle={textStyle} display={display}>
      {!!iconName && (
        <ChakraListIcon className="fa-li" fontSize={size} lineHeight="inherit">
          <Icon iconName={iconName} prefix={iconPrefix} color={iconColor || 'icon-default'} fontSize={size} />
        </ChakraListIcon>
      )}
      {children}
    </ChakraListItem>
  );
};
